/* eslint-disable import/no-anonymous-default-export */
export default{
    baseurl:"https://api.searchable.dev-iuh.xyz",
}